import { render, staticRenderFns } from "./addRecedeMoney.vue?vue&type=template&id=bcd4cd68&scoped=true&"
import script from "./addRecedeMoney.vue?vue&type=script&lang=js&"
export * from "./addRecedeMoney.vue?vue&type=script&lang=js&"
import style0 from "./addRecedeMoney.vue?vue&type=style&index=0&id=bcd4cd68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd4cd68",
  null
  
)

export default component.exports